var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoicemakerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.972 0H9.7825C9.68474 0.000548595 9.58747 0.0139488 9.49319 0.0398574C2.0216 1.08702 0.408659 5.22856 0.0795619 6.56197C0.0271451 6.69336 0.000144784 6.83354 0 6.97504V21.7186C0.00199396 23.9951 1.84341 25.8401 4.11552 25.8421H16.972C19.2441 25.8401 21.0855 23.9951 21.0875 21.7186V4.12343C21.0855 1.84695 19.2441 0.00199779 16.972 0Z",
    fill: "url(#logo_back_paint_grad)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M6.73171 5.84863C7.79628 5.84863 8.65928 4.98397 8.65928 3.91736V1.13096C8.66015 0.620967 9.00279 0.175134 9.49468 0.0439453C2.02309 1.08748 0.410152 5.22903 0.0810547 6.56244C0.248077 6.12733 0.664544 5.83956 1.12983 5.83776L6.73171 5.84863Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5427 21.5121C7.23368 21.5121 4.56836 19.204 4.56836 16.3343C4.56836 15.852 4.95857 15.461 5.43992 15.461C5.92128 15.461 6.31149 15.852 6.31149 16.3343C6.31149 18.2257 8.21013 19.7656 10.5427 19.7656C12.8753 19.7656 14.7776 18.2257 14.7776 16.3343C14.7567 16.0095 14.9177 15.7001 15.1955 15.5314C15.4732 15.3626 15.8215 15.3626 16.0992 15.5314C16.377 15.7001 16.538 16.0095 16.5171 16.3343C16.5171 19.204 13.8373 21.5121 10.5427 21.5121Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_back_paint_grad",
    x1: -0.444452,
    y1: 8.52771,
    x2: 9.04942,
    y2: 17.1872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D97F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#66A0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#74AEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90CAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92CCFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 0.0810547,
    y1: 6.56063,
    x2: 9.49468,
    y2: 6.56063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#A0D5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7E3FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicemakerLogo);
export default __webpack_public_path__ + "static/media/invoicemaker-logo.b53a946a9d0231c721bf5801800dca79.svg";
export { ForwardRef as ReactComponent };